var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 2.82 2.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007aff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 0.059,
    d: "M1.41 0C.632 0 0 .632 0 1.41a1.4 1.4 0 0 0 .268.826l-.175.524.542-.173a1.399 1.399 0 0 0 .775.233c.778 0 1.41-.633 1.41-1.41C2.82.633 2.188 0 1.41 0Zm-.394.716C.989.651.968.648.926.646A.796.796 0 0 0 .88.646a.205.205 0 0 0-.144.05C.694.738.591.836.591 1.04c0 .202.147.398.167.425.021.027.288.448.702.62.324.134.42.122.494.106.108-.023.243-.103.277-.199.034-.096.034-.178.024-.196-.01-.017-.037-.027-.079-.048a6.083 6.083 0 0 0-.28-.133c-.038-.014-.074-.01-.102.03-.04.056-.079.113-.11.146-.025.027-.066.03-.1.016-.045-.019-.173-.064-.33-.204a1.255 1.255 0 0 1-.229-.284c-.024-.041-.002-.065.017-.088.02-.026.04-.044.061-.068.02-.024.032-.036.046-.064.014-.028.004-.056-.006-.077-.01-.02-.093-.223-.127-.305Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/zap.60653128d8cbb79c88168347f2672669.svg";
export { ForwardRef as ReactComponent };